/**
 * Type guard to determine if a given command constructor is broadcastable.
 *
 * Encapsulates the runtime flag check so call sites don't need casts.
 */
export function isBroadcastableCommand(command) {
  return typeof command === 'function' && command.__broadcastable === true;
}